import { HealerUserProfileResponseDTO } from '../../infra/adapters/luminara/userprofile/dto/HealerUserProfileResponse.dto';

export interface HealerProfileState {
  hasError: boolean;
  profile?: HealerUserProfileResponseDTO;
}

export const initialHealerProfileState = () => {
  return {
    hasError: false,
  } as HealerProfileState;
};

export interface HealerProfileAction {
  type: 'HEALER_PROFILE_LOADED_SUCCESSFULLY' | 'HEALER_PROFILE_LOAD_FAILURE' | 'HEALER_LOGGED_OUT';
  payload?: any;
}

const healerProfileModalReducer = (state: HealerProfileState = initialHealerProfileState(), action: HealerProfileAction): HealerProfileState => {
  switch (action.type) {
    case 'HEALER_PROFILE_LOADED_SUCCESSFULLY': {
      return {
        ...state,
        hasError: false,
        profile: action.payload,
      };
    }
    case 'HEALER_PROFILE_LOAD_FAILURE': {
      return { ...state, profile: undefined, hasError: true };
    }
    case 'HEALER_LOGGED_OUT': {
      return initialHealerProfileState();
    }
    default:
      return state;
  }
};

export default healerProfileModalReducer;
